import { AreaVideo } from "../../Features/AreaVideos";
import HtmlRenderer from "../../HtmlRenderer";
import { useLanguage } from "../../hooks/useLanguage";
import React from "react";
import { VideoPlayer } from "../Spotdescription/SpotDescription";

const labels = {
  seeWebsite: {
    da: "Besøg hjemmeside",
    en: "See website",
    de: "Siehe Website",
  },
  email: {
    da: "Email",
    en: "Email",
    de: "Email",
  },
  phone: {
    da: "Telefon",
    en: "Telephone",
    de: "Telefon",
  },
  openingHours: {
    da: "Åbningstider",
    en: "Opening hours",
    de: "Öffnungszeiten",
  },
  facilities: {
    da: "Faciliteter",
    en: "Facilities",
    de: "Anlagen",
  },
  seeWebpage: {
    da: "Se hjemmeside",
    en: "See website",
    de: "Siehe Website",
  },
  bookAccomodation: {
    da: "Book ophold",
    en: "Book accommodation",
    de: "Unterkunft buchen",
  },
  description: {
    da: "Beskrivelse",
    en: "Description",
    de: "Beschreibung",
  },
};

/*
 * This component displays the content of the area video sidebar
 */

export default function AreaVideoSidebar(props: { data?: AreaVideo }) {
  const language = useLanguage();
  if (!props.data) return null;

  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      <div id="certifiedHotel">
        <div className="header clearfix">
          <div>
            <h2 className="overskrift">{props.data.title}</h2>
          </div>

          <VideoPlayer key={props.data.title} src={props.data.videoUrl} />

          <h3>{labels.description[language]}</h3>
          <div style={{ marginBottom: 20 }}>
            <HtmlRenderer html={props.data.description[language]} />
          </div>
        </div>
      </div>
    </div>
  );
}
